(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("grapheditor-webcomponent", [], factory);
	else if(typeof exports === 'object')
		exports["grapheditor-webcomponent"] = factory();
	else
		root["grapheditor-webcomponent"] = factory();
})(self, () => {
return 